import React, { useEffect, useRef, useState } from 'react';
import { TreatmentType } from '../models/superbit-api-models';
import { Select, TimePicker  } from 'antd';
import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce';
import DatePicker from "react-datepicker";
import dayjs from 'dayjs';
import './_TaskAddTask.css';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faPlus, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { SimulatorModel } from '../models/SimulatorModel';
import { WhatsAppModel } from '../models/WhatsAppModel';
// import 'antd/dist/antd.css';

type Props = {
    data: any;
    ClosePopup: Function;
    OnApprove?: Function;
    messageTitle?: string;
    message?: string;
    fromLeadTreatments?: boolean;
};

const ConfirmPopUp = (props: Props) => {

    const closePopup = (status?: string)=>{
        if (props.ClosePopup) {
            props.ClosePopup(status);  
         }
    }

    const approve = () => {
        if (props.OnApprove) {
            props.OnApprove(props.data);
        }
    }

    

    const emptyFunc = () => {}

    useEffect(()=>{
        
    },[])
    
        return ( <>
            <div className={`popup-wrapper small-warning`} style={ props.fromLeadTreatments ? { position: 'fixed'} : {}}>
                <section className="popup-window rtl">
                    <div className="close-icon pointer" onClick={(e:any)=>closePopup()}></div>
                    <div className="popup-content">
                        <div className="popup-header">
                            <div className="popup-title">
                                {props.messageTitle}
                            </div>
                        </div>
                        <div className="popup-body">
                            <div className="parameter-row single-item">
                            {props.message}
                            </div>
                            
                        </div>
                        <div className="popup-footer">
                            <button className="button blue pointer"  onClick={approve}>
                                כן
                            </button>
                            
                            <button className="button white blue-border pointer"  onClick={(e:any)=>closePopup()}>
                                ביטול
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </>  
            
        );
    // }
  }
  export default ConfirmPopUp;